export default __webpack_public_path__ + "static/media/IconTrash.e1bc25ed.svg";